import type { ExternalMessage } from '../../types';

export const isExternalMessage = (entity: any): entity is ExternalMessage =>
	entity.__typename === 'ExternalMessage';

export const getExternalMessageLink = (message: ExternalMessage): string | null =>
	message?.url ?? null;
